import React from 'react';
import { Translation } from 'react-i18next';
import { Button } from 'antd';
import { CloudDownloadOutlined, LoadingOutlined } from '@ant-design/icons';

import Logger from '../../../../../lib/Logger';

const DownloadCSVButton = ({
  isCSVDownloading,
  downloadTemplate,
  ...props
}) => {
  return (
    <Translation>
      {(t) => (
        <Button
          size='small'
          icon={
            isCSVDownloading ? <LoadingOutlined /> : <CloudDownloadOutlined />
          }
          onClick={() => downloadTemplate()}
        >
          {t('action_download_template')}
        </Button>
      )}
    </Translation>
  );
};

export default DownloadCSVButton;

Logger.log('silly', `DownloadCSVButton loaded.`);
